import firebase from 'src/firebase';
import { SESSION_STATES } from 'src/utils/constants';

export const FIREBASE_ACTIONS = {
  initiateSession: (_id) => firebase.firestore().doc(`sessions/${_id}`).set({ state: SESSION_STATES.loading, web: firebase.firestore.FieldValue.serverTimestamp() }, { merge: true }),
  webPulse: (_id) => firebase.firestore().doc(`sessions/${_id}`).update({ web: firebase.firestore.FieldValue.serverTimestamp() }, { merge: true }),
  errorDetected: (_id) => firebase.firestore().doc(`sessions/${_id}`).update({ state: SESSION_STATES.error }),
  updateTs: (_id, seekTime) => firebase.firestore().doc(`sessions/${_id}`).update({ ts: seekTime }, { merge: true }),
  controlPlayback: (_id, state) => firebase.firestore().doc(`sessions/${_id}`).update({ state }),
  updateSeek: (_id, seek_to) => firebase.firestore().doc(`sessions/${_id}`).update({ ts: seek_to, 'seek.rat': firebase.firestore.FieldValue.serverTimestamp() }),
  donePlaying: (_id) => firebase.firestore().doc(`sessions/${_id}`).update({ done: true }),
  disconnect: (_id) => firebase.firestore().doc(`sessions/${_id}`).update({ disconnect_web: true }),
};

export const differ = (nextData, prevData) => {
  if(!prevData.url && !!nextData.url) return { ...prevData, ...nextData };

  if(prevData.state !== nextData.state){
    // State changed to playing/paused
    console.log('detected --- ', prevData.state, 'to', nextData.state);
    return { ...prevData, ...nextData };
  };

  if((!prevData?.seek?.uat && !!nextData?.seek?.uat) || (nextData?.seek?.uat?.toDate() > prevData?.seek?.uat?.toDate())){
    // Seek player - when seek.uat is updated
    console.log('detected --- seek - ', prevData.ts, 'to', nextData?.seek?.sec);
    return { ...prevData, ...nextData, seek_to: nextData.seek.sec };
  };

  return { ...prevData, ...nextData, initiate: false };
};
